<template>
	<page-content-layout class="cases" title="Cases">
		<button-view v-if="false" slot="tools" label="Opret" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Modtaget',
				value: 'received'
			},
			{
				label: 'Åben',
				value: 'open'
			},
			{
				label: 'Lukket',
				value: 'closed'
			}
		]" v-model="active" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Status',
				name: ['status'],
				translation: _status,
				template: {
					name: 'status',
					params: {
						color: {
							name: ['status'],
							translation: _statusColors
						},
						description: {
							name: ['status'],
							translation: _statusDesc
						}
					}
				},
				weight: 2
			},
			{
				label: 'Oprettet',
				name: 'created',
				filter: 'date',
				weight: 2
			},
			{
				label: 'Afsluttet',
				name: 'closed',
				filter: 'date',
				weight: 2
			},
			{
				label: 'Opgave',
				name: ['_embedded', 'task', 'num'],
				align: 'right',
				weight: 1
			},
			{
				label: 'Type',
				name: ['_embedded', 'type'],
				weight: 1
			},
			{
				label: 'Tur',
				name: ['_embedded', 'tour'],
				align: 'right',
				weight: 1
			},
			{
				label: 'Kunde',
				name: ['details', 'contact', 'name'],
				weight: 2
			},
			{
				label: 'Skadesum',
				name: ['sum'],
				align: 'right',
				filter: 'number',
				weight: 2
			},
			{
				label: 'Medarb. andel',
				name: ['_embedded', 'employee_part'],
				align: 'right',
				filter: 'number',
				weight: 2
			},
			{
				label: 'Forsikr. andel',
				name: 'insurance_part',
				align: 'right',
				filter: 'number',
				weight: 2
			},
			{
				label: 'Intern andel',
				name: 'internal_part',
				align: 'right',
				filter: 'number',
				weight: 2
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				},
				weight: 1
			}
		]" :items="_items" @itemClick="itemClick" @context="itemContext" />
	</page-content-layout>
</template>

<script>
	import Window from '../windows/ClaimWindow'
	import MailWindow from '../windows/MailWindow'
	import TextWindow from '../windows/TextWindow'
	import EmployeeHistoryWindow from '../windows/EmployeeHistoryWindow'
	import NewTableView from '../views/NewTableView'
	import ContextPopupView from '../views/ContextPopupView'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import { bus } from '../../bus'

    export default {
		data() {
			return {
				items: [],
				active: 'received'
			};
		},
		components: {
			newTableView: NewTableView
		},
		computed: {
			_items() {
				if (this.items === null) return [];

				var r = [];

				for (var i = 0; i < this.items.length; ++i) {
					if (this.items[i].status == this.active) {
						r.push(this.items[i]);
					}
				}

				return r; 
			},
			_status() {
				return {
					received: 'Modtaget',
					open: 'Åben',
					closed: 'Lukket'
				};
			},
			_statusDesc() {
				return this._status;
			},
			_statusColors() {
				return {
					received: 'yellow',
					open: 'yellow',
					closed: 'green'
				};
			}
		},
		methods: {
			update() {
				var self = this;

				self.items = null;

				this.axios
					.get('/claims/')
					.then(function (r) {
						self.items = r.data;
					});
			},
			async itemClick(item) {
				var self = this;
				var ent = (await this.axios.get(`/claims/${item.id}/`)).data;

				this.$store.state.windowStack.push(Window, {ent: ent, async submit(ent) {
					
					
					await self.axios.put(`/claims/${ent.id}/`, ent);

					bus.$emit('update');
					self.$store.state.windowStack.pop();
					return false;
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/claims/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemContext(item, event) {
				event.stopPropagation();

				

				var self = this;

				const reportImages = item.details.files.filter((item) => { 
					const parts = item.label.split('.');
					const last = parts[parts.length - 1].toString().toLowerCase();

					return last == 'jpg' || last == 'jpg' || last == 'png';
				});

				const taskImages = item._embedded.task.hasOwnProperty('details') && item._embedded.task.details.hasOwnProperty('photos') ? item._embedded.task.details.photos : [];

				var actions = [
					{
						label: 'Udskriv skade',
						enabled: true,
						action: async function () {
							window.open(process.env.VUE_APP_API + '/claims/' + item.id + '/print/?token=' + self.$store.state.auth);
						}
					},
					null,
					{
						label: 'Åben opgave',
						action: async function () {
							// Expecting a move task
							var ent = await MoveTaskModel.read(self.axios, item.task_id);

							self.$store.state.windowStack.push(MoveTaskWindow, {
								value: ent,
								async submit(entity) {
									if (await MoveTaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('update');
									}
								}
							});
						}
					},
					null,
					{
						label: 'Send til e-mail',
						action: async function () {
							const email = prompt('E-mail');

							if (!email) return;

							await self.axios.post(`/claims/${item.id}/email`, {
								email: email
							});
						}
					},
					{
						label: 'Udbed kommentarer',
						action: async function () {
							const email = prompt('E-mail', item._embedded.employees.map((item) => {
								return item.email;
							}).join(', '));

							if (!email) return;

							await self.axios.post(`/claims/${item.id}/comments`, {
								email: email
							});
						}
					},
					null,
					{
						label: `Vis billeder fra anmeldelse (${reportImages.length})`,
						action() {
							self.$store.commit('gallery', reportImages);
						},
						enabled: reportImages.length > 0
					},
					{
						label: `Vis billeder fra opgave (${taskImages.length})`,
						action() {
							self.$store.commit('gallery', taskImages);
						},
						enabled: taskImages.length > 0
					},
					{
						label: 'Sammenlign billeder',
						action() {
							self.$store.commit('cmp_gallery_1', item.details.files.filter((item) => { 
								const parts = item.label.split('.');
								const last = parts[parts.length - 1].toString().toLowerCase();

								return last == 'jpg' || last == 'jpg' || last == 'png';
							}));

							self.$store.commit('cmp_gallery_2', item._embedded.task.hasOwnProperty('details') && item._embedded.task.details.hasOwnProperty('photos') ? item._embedded.task.details.photos : []);
						},
						enabled: taskImages.length > 0 && reportImages.length > 0
					},
				];

				actions.push(null);

				actions.push({
					label: 'Slet',
					action: async function () {
						self.itemDelete(item);
					}
				});


				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
		},
		mounted: function () {
			this.axios.put('/activity/claims/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss">

</style>